import { BuildNode } from "@common/build/types";

import {
    setValueAtPath
} from "./jsxHelpers";
import { PropMapping } from "./jsxMapping";


export function validateDynamicGridQuery(query: any): void {
    if (!query || typeof query !== "object") {
        throw new Error("Query must be an object for dynamic grids");
    }
    const { dataType, limit, order, match, queries } = query;
    if (!dataType || !["products", "customers", "orders"].includes(dataType)) {
        console.warn("Query 'dataType' must be either 'products', 'customers' or 'orders'");
        query.dataType = "products";
    }
    if (typeof limit !== "number" || limit <= 0) {
        console.warn("Query 'limit' must be a positive number");
    }
    if (order) {
        if (typeof order !== "object" || !order.orderBy || !order.orderDirection) {
            console.warn("Query 'order' must have 'orderBy' and 'orderDirection' fields");
            query.order = { orderBy: "name", orderDirection: "ascending" };
        }
        if (!["ascending", "descending"].includes(order.orderDirection)) {
            console.warn("Query 'order.orderDirection' must be 'ascending' or 'descending'");
            query.order.orderDirection = "ascending";
        }
    }
    if (dataType === "customers" && queries && typeof queries !== "object") {
        console.warn("Query 'queries' for customers must be an object");
        query.queries = {};
    }
    if (dataType === "products" && match && typeof match !== "object") {
        console.warn("Query 'match' for products must be an object");
        query.match = {};
    }
}




export const DYNAMIC_GRIDS_PROP_MAPPINGS: PropMapping[] = [
    { nodePath: ["groupBy"], jsxProp: "groupBy" },
    { nodePath: ["dividerStyles"], jsxProp: "dividerStyles" },
    {
        nodePath: ["query"],
        jsxProp: "query",
        customAddJSXAttToNode: (node: BuildNode, value: any) => {
            validateDynamicGridQuery(value);
            setValueAtPath(node, ["query"], value);
        }
    }
];
